const FormikError = ({ children: errMessage }: any) => {
  return <div className="text-[#d20707]">{errMessage}</div>;
};

export default FormikError;
